import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";
import { Link } from "react-router-dom";
import {
  transition,
  setMovement,
  stopMovement
} from "../Utils/React3dNavigation";

class Hero4 extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut, paused: true });

    //horse rocking
    setMovement();

    //set color of links
    let links = document
      .getElementById("navigation")
      .getElementsByClassName("link");
    for (var i = 0; i < links.length; i++) {
      links[i].style.color = "#c5c5c5";
    }
  }

  enterTransition = time => {
    this.tl.to(this.hero, time, { opacity: 1 });
    this.tl.play();
  };

  exitTransition = time => {
    this.tl.fromTo(
      this.hero,
      time,
      {
        opacity: 1
      },
      {
        transform: "translateX(-70px)",
        opacity: 0
      }
    );
    this.tl.play();
  };

  componentWillUnmount() {
    stopMovement();

    //set color of links
    let links = document
      .getElementById("navigation")
      .getElementsByClassName("link");
    for (var i = 0; i < links.length; i++) {
      links[i].style.color = "";
    }
  }

  render = () => {
    return (
      <div id="hero4" className="section" ref={hero => (this.hero = hero)}>
        <div className="aboutText">
          <div className="h2 selectedText">
            We are ready to build your next product<br />
            or join your team remotely
          </div>

          <div className="seewhatwedid">
            See our &#160;
            <Link to="/work">
              <div className="link" onClick={() => transition("/work")}>
                work
              </div>
            </Link>
            &#160; or &#160;
            <Link to="/contact">
              <div className="link" onClick={() => transition("/contact")}>
                contact us
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  };
}

export default Hero4;



// WEBPACK FOOTER //
// ./src/components/Front/Hero4.js